export default __webpack_public_path__ + "static/media/brochure_7.9785efe5.jpg";